/**
 * @name DrawerContent
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Componente principal que renderiza o conteúdo do drawer lateral.
 * @package src/components/layouts/UserLayout/components/UserSideBar/DrawerContent.tsx
 **/

import { Box, Divider, List, Stack, Typography } from '@mui/material';
import React from 'react';

import useUserContext from '../../../../../../contexts/UserContext/useUserContext';
import { getPrimeiroNome } from '../../../../../../utils/getPrimeiroNome';
import { saudacao } from '../../../../../../utils/saudacao';
import AccountIconButton from '../../../../../common/iconButtons/AccountIconButton';
import LogoutIconButton from '../../../../../common/iconButtons/LogoutIconButton';
import ThemeToggleIconButton from '../../../../../common/iconButtons/ThemeToggleIconButton';
import Logo from '../../../../../common/Logo';
import { useMenuStates } from '../hooks';
import { menuConfig } from '../menuConfig';
import { DrawerContentProps } from '../types';
import { MenuItemRenderer } from './MenuItemRenderer';

const DrawerContent: React.FC<DrawerContentProps> = ({ onClose }) => {
     const { userData, signOut } = useUserContext();
     const { openKeys, toggleMenu } = useMenuStates();

     const handleLogout = () => {
          signOut();
          onClose?.();
     };

     return (
          <Stack
               width={270}
               direction={'column'}
               justifyContent={'start'}
               role='presentation'
          >
               <Box margin={2}>
                    <Logo height={100} />
               </Box>
               <Stack
                    flexDirection={'row'}
                    justifyContent={'center'}
                    marginTop={1}
               >
                    <Typography
                         variant='subtitle2'
                         align='center'
                    >
                         {saudacao()}, {getPrimeiroNome(userData?.nome)}
                    </Typography>
               </Stack>
               <Box mt={1}>
                    <Divider />
                    <List>
                         {menuConfig.map((item) => (
                              <MenuItemRenderer
                                   key={item.key}
                                   item={item}
                                   onClose={onClose}
                                   openKeys={openKeys}
                                   onToggle={toggleMenu}
                              />
                         ))}
                    </List>
                    <Divider />
               </Box>
               <Stack
                    direction={'row'}
                    justifyContent={'center'}
                    gap={2}
               >
                    <AccountIconButton onClick={onClose} />
                    <ThemeToggleIconButton />
                    <LogoutIconButton onClick={handleLogout} />
               </Stack>
               <Divider />
          </Stack>
     );
};

export default DrawerContent;
